import React, { useContext, useEffect, useState } from "react";
// Soft UI Dashboard PRO React example components
import { useNavigate } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Skeleton from "@mui/material/Skeleton";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";

import ImportSingleStyleModal from "pages/de/portfolio/components/ImportSingleStyleModal";
import UploadProfileModal from "pages/de/portfolio/components/UploadProfileModal";
import ImportSingleCollectionModal from "pages/de/portfolio/components/ImportSingleCollectionModal";
import AddProductCard from "pages/de/portfolio/components/AddProductCard";
import ProductCard from "pages/de/portfolio/components/ProductCard";

import Gallery from "pages/de/portfolio/components/Gallery";
import Profile from "pages/de/portfolio/components/Profile";

import { Carousel } from "antd";

import api from "services/api";

import toast from "react-hot-toast";
import SortableList, { SortableItem } from "react-easy-sort";

const Template3 = ({
  handle,
  handleClickProduct,
  handleRefresh,
  handleOk,
  onSortEnd,
  handleImportCollection,
  handleShowImportCollection,
  handleClickItem,
  userData,
}) => {
  const [formattedStyleGroup, setFormattedStyleGroup] = [];

  const { store } = useContext(StoreContext);
  const account = useContext(AccountContext);

  let portfolioData = account?.metadata?.portfolio_content || {};
  let storeData = store;
  if (handle) {
    portfolioData = userData?.metadata?.portfolio_content || {};
    storeData = userData?.stores?.[0] || {};
  }
  let collectionStyleList = portfolioData["col_0"] || [];
  let featuredStyleList = portfolioData["style_0"] || [];

  const handleFormatGroup = (num, list) => {
    let temp = [];
    let group = [];
    let myWidth = "33.33%";
    if (num > 3) {
      myWidth = 100 / num + "%";
    }

    for (let i = 0; i < list.length; i++) {
      if ((i + 1) % num == 0) {
        group.push(list[i]);
        const grouped = group.map((p) => (
          <ProductCard
            index={i}
            product={p}
            imageOnly={true}
            handleClick={handleClickItem}
            editable={handle ? false : true}
            slot="style_0"
            handleRefresh={handleRefresh}
            isOriginalSize
            maxHeight={420}
            height={420}
            width={"100%"}
            sx={{ height: "fit-content" }}
          />
        ));
        temp.push(grouped);
        group = [];
      } else {
        group.push(list[i]);
      }
    }
    if (group.length > 0) {
      const grouped = group.map((p, i) => (
        <ProductCard
          index={i}
          product={p}
          imageOnly={true}
          handleClick={handleClickItem}
          editable={handle ? false : true}
          slot="style_0"
          handleRefresh={handleRefresh}
          isOriginalSize
          maxHeight={420}
          height={420}
          width={"100%"}
          sx={{ height: "fit-content" }}
        />
      ));
      temp.push(grouped);
    }
    return (
      <Carousel
        arrows={true}
        dots={false}
        vertical={false}
        adaptiveHeight
        prevArrow={
          <div>
            <button
              class="react-multiple-carousel__arrow react-multiple-carousel__arrow--left "
              type="button"
            ></button>
          </div>
        }
        nextArrow={
          <div>
            <button
              class="react-multiple-carousel__arrow react-multiple-carousel__arrow--right "
              type="button"
            ></button>
          </div>
        }
      >
        {" "}
        {temp.map((group) => {
          return (
            <div>
              <SuiBox
                style={{ display: "flex" }}
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="row"
              >
                {group.map((p) => (
                  <SuiBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="row"
                  >
                    {p}
                  </SuiBox>
                ))}{" "}
              </SuiBox>
            </div>
          );
        })}
      </Carousel>
    );
  };

  return (
    <div>
      <Profile userData={userData} handleRefresh={handleRefresh} slot="profile" />
      <SuiBox>
        <SuiBox my={2}>
          <SuiBox display="flex" justifyContent="space-between" sx={{ mb: 1 }}>
            <SuiTypography variant="h5" fontWeight="medium" textTransform="capitalize">
              Featured Styles
            </SuiTypography>
            {handle ? (
              <div />
            ) : (
              <AddProductCard
                slot="style_0"
                handleRefresh={handleRefresh}
                sx={{ height: 360 }}
                draggable={false}
                type="button"
              />
            )}
          </SuiBox>
        </SuiBox>
        <SuiBox>
          <SuiBox px={6}>
            {handle ? (
              handleFormatGroup(3, featuredStyleList)
            ) : (
              <div style={{ overflowX: "auto", widht: "100%" }} className="mx-2">
                <SortableList
                  onSortEnd={(oldIndex, newIndex) => onSortEnd(oldIndex, newIndex, "style_0")}
                  className="flex flex-row w-full"
                  draggedItemClassName="bg-color-white"
                  distance={10}
                >
                  {featuredStyleList.map((p, index) => {
                    let myWidth = "33.33%";

                    return (
                      <SuiBox key={index} style={{ width: myWidth, minWidth: 330, margin: "auto" }}>
                        <SortableItem key={index} draggable={handle ? false : true}>
                          <div className="my-2">
                            <ProductCard
                              index={index}
                              product={p}
                              imageOnly={true}
                              handleClick={handleClickItem}
                              editable={handle ? false : true}
                              slot="style_0"
                              handleRefresh={handleRefresh}
                              isOriginalSize
                              maxHeight={380}
                              width={"auto"}
                              sx={{ height: "fit-content" }}
                            />
                          </div>
                        </SortableItem>
                      </SuiBox>
                    );
                  })}{" "}
                </SortableList>
              </div>
            )}
          </SuiBox>
        </SuiBox>
        <SuiBox>
          <SuiBox sx={{ py: 2 }}>
            <SuiBox display="flex" justifyContent="space-between" sx={{ mb: 1 }}>
              <SuiTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                Featured Collection
              </SuiTypography>
              {handle ? (
                <div />
              ) : (
                <SuiButton variant="gradient" color="dark" onClick={handleShowImportCollection}>
                  Import Collection
                </SuiButton>
              )}
            </SuiBox>

            <SortableList
              onSortEnd={(oldIndex, newIndex) => onSortEnd(oldIndex, newIndex, "col_0")}
              className="flex px-3 items-end overflow-x-auto"
              draggedItemClassName="bg-color-white"
              distance={10}
            >
              {collectionStyleList.map((p, index) => (
                <SuiBox key={index}>
                  <SortableItem
                    key={index}
                    style={{ width: "100%" }}
                    draggable={handle ? false : true}
                  >
                    <div className="mx-4 my-2">
                      <ProductCard
                        index={index}
                        product={p}
                        imageOnly={false}
                        handleClick={handleClickItem}
                        editable={handle ? false : true}
                        slot="col_0"
                        handleRefresh={handleRefresh}
                        width={300}
                        maxHeight={360}
                        isOriginalSize
                        height="auto"
                      />
                    </div>
                  </SortableItem>
                </SuiBox>
              ))}{" "}
              {handle ? null : (
                <SuiBox
                  sx={{
                    width: 300,
                    flex: "0 0 auto",
                  }}
                >
                  <SortableItem key={"add-image"} style={{ width: "100%" }}>
                    <div className="mx-2 my-2" draggable={false} ondragstart={null}>
                      <AddProductCard
                        slot="col_0"
                        handleRefresh={handleRefresh}
                        sx={{ height: 360 }}
                        draggable={false}
                      />{" "}
                    </div>
                  </SortableItem>
                </SuiBox>
              )}
            </SortableList>
          </SuiBox>
        </SuiBox>
      </SuiBox>

      <Gallery />
    </div>
  );
};

export default Template3;
